import { render, staticRenderFns } from "./CampaignItems.vue?vue&type=template&id=0b90e004&"
import script from "./CampaignItems.vue?vue&type=script&lang=js&"
export * from "./CampaignItems.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports